import { render, staticRenderFns } from "./qbDetails.vue?vue&type=template&id=44d5a2ea&scoped=true&"
import script from "./qbDetails.vue?vue&type=script&lang=js&"
export * from "./qbDetails.vue?vue&type=script&lang=js&"
import style0 from "./qbDetails.vue?vue&type=style&index=0&id=44d5a2ea&prod&lang=css&"
import style1 from "./qbDetails.vue?vue&type=style&index=1&id=44d5a2ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d5a2ea",
  null
  
)

export default component.exports